import { render } from "./LoginButtons.vue?vue&type=template&id=426f0a3a"
import script from "./LoginButtons.vue?vue&type=script&lang=js"
export * from "./LoginButtons.vue?vue&type=script&lang=js"
script.render = render

export default script